import { inject, Injectable } from "@angular/core";

import { AuthService } from "./auth.service";
import { ThemeService } from "./theme.service";
import { NavbarService } from "./navbar.service";
import { DeviceService } from "./device.service";
import { FontService } from "./font.service";

@Injectable({
  providedIn: "root",
})
export class InitService {
  authService = inject(AuthService);
  themeService = inject(ThemeService);
  navbarService = inject(NavbarService);
  deviceService = inject(DeviceService);
  fontService = inject(FontService);

  init(): void {
    this.authService.init();
    this.themeService.init();
    this.navbarService.init();
    this.deviceService.init();
    this.fontService.init();
  }
}
